const form = {
  id: 'createIssues',
  title: 'Create Issue',
  description: 'Create a new project issue.',
  questions: [
    {
      label: 'Project',
      type: 'select',
      required: true,
      values: ['IT Helpdesk (ITREQ)', 'SalesForce Helpdesk (SFREQ)', 'HR Helpdesk (HRREQ)'],
    },
    {
      label: 'Issue Type',
      type: 'select',
      required: true,
      values: ['Task', 'Bug'],
    },
    {
      label: 'Summary',
      type: 'text',
      required: true,
    },
    {
      label: 'Reporter',
      type: 'user',
      required: true,
    },
    {
      label: 'Due Date',
      type: 'text',
      required: true,
    },
    {
      label: 'Description',
      type: 'textarea',
      required: true,
    },
    {
      label: 'Assignee',
      type: 'select',
      values: ['Automatic'],
    },
    {
      label: 'Priority',
      type: 'select',
      values: ['High', 'Medium', 'Low'],
    },
  ],
};

export default form;
